import React from "react";
import { FiFacebook } from "react-icons/fi";
import { SlSocialLinkedin } from "react-icons/sl";
import { IoLogoInstagram , IoMail } from "react-icons/io5";
import { FaTiktok, FaPhoneAlt } from "react-icons/fa";
import { PiTiktokLogo } from "react-icons/pi";

function UpperNavBar() {
  return (
    <div className="bg-primary-color w-full h-auto py-2">
      <div className="flex flex-wrap justify-between items-center px-2 sm:px-4 md:px-6 lg:px-10 xl:px-12 h-full">
        
        {/* Social Media Icons */}
        <div className="flex gap-2 sm:gap-3">
          <a
            href="https://www.instagram.com/casrilankasab/?igsh=MW9naWludWN0ZXZ5aw%3D%3D#"
            className="text-white hover:text-Footer-color"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoInstagram className="text-sm sm:text-base md:text-lg" />
          </a>
          <a
            href="https://web.facebook.com/sabcasl"
            className="text-white hover:text-Footer-color"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiFacebook className="text-sm sm:text-base md:text-lg" />
          </a>
          <a
            href="https://www.linkedin.com/company/ca-sri-lanka-school-of-accounting-business/?viewAsMember=true"
            className="text-white hover:text-Footer-color"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialLinkedin className="text-sm sm:text-base md:text-lg" />
          </a>
          <a
            href="https://www.tiktok.com/@sab.campus.ca.srilanka?_t=ZS-8tKFvOITMJd&_r=1"
            className="text-white hover:text-Footer-color"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PiTiktokLogo className="text-sm sm:text-base md:text-lg" />
          </a>
        </div>

        {/* Contact Info (Stacked on Small Screens) */}
        <div className="flex flex-col sm:flex-row justify-end items-center gap-2 sm:gap-6">
          {/* Phone Number */}
          <p className="text-white flex items-center gap-1 sm:gap-2 text-sm sm:text-base md:text-lg">
            <FaPhoneAlt className="text-sm sm:text-base md:text-lg" />
            <a href="tel:+94112413500" className="hover:underline">
            +94 112 807 407
            </a>
          </p>

          {/* Email */}
          <p className="text-white flex items-center gap-1 sm:gap-2 text-sm sm:text-base md:text-lg">
            <IoMail className="text-sm sm:text-base md:text-lg" />
            <a
              href="mailto:sab@casrilanka.org"
              className="text-blue-300 font-inter hover:underline"
            >
              sab@casrilanka.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default UpperNavBar;
